import React, { useEffect, useState } from "react";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import AlertTemplate from "react-alert-template-basic";
import EnvironmentContext from "./components/contexts/EnvironmentContext";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import axios from "axios";
import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import PublicForm from "./components/forms/public/PublicForm";
import { loadRuntimeConfig } from "./services/runtimeConfig";
import { setHttpBaseURL } from "./services/http";

export default function Main() {
  axios.defaults.baseURL = process.env.REACT_APP_TAKAOKABOTS_API_URL;
  axios.defaults.headers.get["Accept"] = "application/json";
  axios.defaults.headers.post["Accept"] = "application/json";

  const [takaokabotsApiUrl, setTakaokaBotsApiUrl] = useState("");
  const [runtimeConfig, setRuntimeConfig] = useState(null);

  useEffect(() => {
    loadRuntimeConfig().then((configJson) => {
      const apiUrl = configJson.TAKAOKABOTS_API_URL || process.env.REACT_APP_TAKAOKABOTS_API_URL;
      if (apiUrl) {
        axios.defaults.baseURL = apiUrl;
        setHttpBaseURL(apiUrl);
        setTakaokaBotsApiUrl(apiUrl);
      }
      setRuntimeConfig(configJson);
    });
  }, []);

  const options = {
    position: positions.TOP_CENTER,
    timeout: 2000,
    offset: "30px",
    transition: transitions.SCALE,
  };

  const publicPath = window.location.pathname;
  const publicRoute = [
    { prefix: "/f/", mode: "open" },
    { prefix: "/forms/open/", mode: "open" },
    { prefix: "/r/", mode: "invite" },
  ].find(({ prefix }) => publicPath.startsWith(prefix));
  if (publicRoute) {
    // Um "%" solto no link (ex.: /f/abc%) faz decodeURIComponent lançar URIError. Como
    // isto roda no corpo do render, o paciente veria tela branca em vez do card de
    // formulário indisponível que o PublicForm já sabe mostrar.
    const bruto = publicPath.slice(publicRoute.prefix.length);
    let token;
    try {
      token = decodeURIComponent(bruto);
    } catch (e) {
      token = bruto;
    }
    return (
      <AlertProvider template={AlertTemplate} {...options}>
        <PublicForm token={token} mode={publicRoute.mode} />
      </AlertProvider>
    );
  }

  if (!runtimeConfig) {
    return null;
  }

  return (
    <EnvironmentContext.Provider
      value={{
        takaokabotsApiUrl,
        setTakaokaBotsApiUrl,
        updateContext: (context) => {
          setTakaokaBotsApiUrl(context.takaokabotsApiUrl);
        },
      }}
    >
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          <AlertProvider template={AlertTemplate} {...options}>
            <BrowserRouter>
              <Routes></Routes>
            </BrowserRouter>
          </AlertProvider>
        </MsalAuthenticationTemplate>
    </EnvironmentContext.Provider>
  );
}
